import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';
import './autosuggest.css';


class AutoSuggestContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: []
    };
  }
  componentDidMount(){
    let value = this.props.prevInfo

    if(!this.props.create){
      if(this.props.prevInfo !== undefined){
        this.setState({
          value: value.value
        })
      }
    }else{
      if(Object.keys(this.props.prevInfo).length !== 0){
        this.setState({
          value: value.value
        })
      }
    }
  }
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : this.props.suggestions.filter(v =>
      v.value.toLowerCase().slice(0, inputLength) === inputValue.toLowerCase()
    );
  };

  getSuggestionValue = (suggestion) =>{
    return suggestion.value;
  };

  renderSuggestion = suggestion => {
   return(<div>
      {suggestion.value}
    </div>);
  };

  onChange = (event, { newValue }) => {
    let name = this.props.option;
    var found = this.props.suggestions.find(v => {
      return newValue.toLowerCase().trim() === v.value.toLowerCase().trim();
    });

    if (typeof found === 'undefined') {
      this.props.handleCreate(name, newValue);
    } else {
      this.props.handleChange(name, found);
    }

    this.setState({
      value: newValue
    });
  };
  onSuggestionsFetchRequested = ({ value, reason }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  onSuggestionSelected = (e, {suggestion, method}) => {
    let name = this.props.option;
    this.setState({value: suggestion.value})
    this.props.handleChange(name, suggestion)
  };
  onBlur = (event, {highlightedSuggestion}) => {
    let newValue = this.state.value;
    var found = this.props.suggestions.find(v => {
      return newValue.toLowerCase() === v.value.toLowerCase();
    });

    if(found !== undefined){
      this.setState({
        value: found.value
      })
    }
  };
  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: '',
      value,
      onBlur: this.onBlur,
      onChange: this.onChange,
    };
    return (
        <div className="auto-sug">
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                inputProps={inputProps}
            />
        </div>
    );
  }
}
export default AutoSuggestContainer;
